// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608052145/js/" + chunkId + "." + {"44":"062f7ada","225":"496999d2","481":"7f0e4663","486":"02494aa5","770":"a1944a99"}[chunkId] + ".0.16893437969065805.chunk.js";
};